import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Header from './Header.js'
import Footer from './Footer.js'
import Toolbar from './Toolbar.js'
import FileView from './FileView.js'
import redux from '../redux/index.js'

const TemplatesPage = ({ getData, strings }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  useEffect(getData, [])

  const onHeaderMenuOpen = (event) => setMenuAnchorEl(event.currentTarget)
  const onHeaderMenuClose = () => setMenuAnchorEl(null)

  return (
    <>
      <Header title={strings.templates_page_title} onLogoClick={onHeaderMenuOpen} />
      <Toolbar menuAnchorEl={menuAnchorEl} onMenuClose={onHeaderMenuClose} />
      <div style={fileViewStyle}>
        <FileView />
      </div>
      <div style={footerStyle}>
        <Footer showSaveButton={false} showSendAndFileButton={false} />
      </div>
    </>
  )
}

const border = '1px solid #a3a3a3'

const fileViewStyle = {
  position: 'absolute',
  top: 90,
  bottom: 50,
  width: '100%',
  overflow: 'auto',
  background: 'white',
  border
}

const footerStyle = {
  position: 'absolute',
  bottom: 0,
  width: '100%'
}

const mapStateToProps = (state) => {
  return {
    strings: state.locale.strings
  }
}

const mapDispatchToProps = (dispatch) => {
  const { files } = redux.actions
  return {
    getData: () => {
      dispatch(files.getTemplatesRootFolder())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplatesPage)
